import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P411List from "./P411List";
import P411Search from "./P411Search";
//CSS
import "../../../components/DataTable/DataTable.css";
//SERVICE
import { P411GetDataList } from "../../../service/400/P411Service";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P411() {


    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchWord, setSearchWord] = useState("");
    const [contractNo, setContractNo] = useState("");

    // SEARCH
    const [searchData] = useState({
        searchWord: "",
        contractNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }

        const P411_searchWord = sessionStorage.getItem("P411_searchWord");
        const P412_back = sessionStorage.getItem("P412_back");
        const P411_contractNo = sessionStorage.getItem("P411_contractNo");
        console.log("P411_searchWord", P411_searchWord);
        console.log("P412_back", P412_back);
        console.log("P411_contractNo1 : ", P411_contractNo);
        if (P411_searchWord !== null && P411_searchWord !== undefined && P412_back !== null && P412_back !== undefined && P411_contractNo !== null && P411_contractNo !== undefined) {
            setSearchWord(P411_searchWord);
            setContractNo(P411_contractNo);
            submitForm(P411_searchWord, P411_contractNo);

        }else if (P411_searchWord == null && P411_searchWord == undefined && P412_back !== null && P412_back !== undefined && P411_contractNo !== null && P411_contractNo !== undefined) {
    
            setContractNo(P411_contractNo);
            submitForm("", P411_contractNo); 
        }else if (P411_searchWord !== null && P411_searchWord !== undefined && P412_back !== null && P412_back !== undefined && P411_contractNo == null && P411_contractNo == undefined) {
            setSearchWord(P411_searchWord);
            submitForm(P411_searchWord, "");

        }else {
            submitForm("", "");
        }
        sessionStorage.removeItem("P412_back");
    }, []);

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const submitForm = (submitForm, contractNos) => {
        console.log("P411_contractNo ", contractNos)
        setLoading(true);
        let newData = {
            userId: searchData.userId,
            searchWord: submitForm,
            contractNo: contractNos   === undefined ? contractNo : contractNos,
        };

        P411GetDataList(newData).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">สัญญาก่อสร้าง</h2>
                        <hr/> */}
                        <P411Search searchWord={searchWord} contractNo={contractNo} setSearchWord={setSearchWord} setContractNo={setContractNo} submitForm={submitForm} />
                        <P411List dataTable={dataTable} />
                    </div>
                </div>
            </div>
        </>
    );
}
